import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Wrapper = styled.div<{ show: boolean }>`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	width: 100%;

	@media ${({ theme }) => theme.medias.desktop} {
		max-width: 385px;
		min-width: 385px;
		width: 100%;
		height: 100%;
	}
	${props => (props.show ? '' : `display: none;`)}
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	background: #fff;
	height: 61px;
	box-shadow: 0px 2px 4px rgba(46, 45, 55, 0.16);

	@media ${({ theme }) => theme.medias.desktop} {
		padding: 0 17px;
		height: 73px;
		box-shadow: none;
	}
`;

export const Title = () => css`
	button,
	a {
		display: flex;
		align-items: center;
	}
`;

export const ListContent = styled.div`
	height: calc(100dvh - 181px);
	border-top: 1px solid #e4e4e4;

	position: relative;
	overflow: hidden;

	@media ${({ theme }) => theme.medias.desktop} {
		height: 100%;
	}

	@media ${({ theme }) => theme.medias.mobile} {
		height: 100dvh;
		border-top: none;
	}

	& > div:first-of-type > div {
		${({ theme }) => theme.mixins.scrollBar}

		::-webkit-scrollbar {
			width: 4px;
		}

		::-webkit-scrollbar-thumb {
			width: 4px;
			background-color: #d6d6de;
		}
	}
`;
